/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Shift } from './Shift';
import {
    ShiftFromJSON,
    ShiftFromJSONTyped,
    ShiftToJSON,
    ShiftToJSONTyped,
} from './Shift';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';

/**
 * 
 * @export
 * @interface ListShiftReplacementsResponse
 */
export interface ListShiftReplacementsResponse {
    /**
     * 
     * @type {Array<Shift>}
     * @memberof ListShiftReplacementsResponse
     */
    data: Array<Shift>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListShiftReplacementsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListShiftReplacementsResponse interface.
 */
export function instanceOfListShiftReplacementsResponse(value: object): value is ListShiftReplacementsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListShiftReplacementsResponseFromJSON(json: any): ListShiftReplacementsResponse {
    return ListShiftReplacementsResponseFromJSONTyped(json, false);
}

export function ListShiftReplacementsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListShiftReplacementsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ShiftFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListShiftReplacementsResponseToJSON(json: any): ListShiftReplacementsResponse {
      return ListShiftReplacementsResponseToJSONTyped(json, false);
  }

  export function ListShiftReplacementsResponseToJSONTyped(value?: ListShiftReplacementsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ShiftToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

